import React from 'react';

export default function PhotoStrip() {
  return (
    <div className="photo-strip">
      <div className="strip-stat">
        <div className="strip-stat-inner">
          <div className="strip-stat-num">Experienced</div>
          <div className="strip-stat-label">Events Delivered</div>
        </div>
      </div>

      <div className="strip-centre">
        <img src="/images/midgameputt.png" alt="Mid Game RushPutt" className="strip-centre-bg" />
      </div>

      <div className="strip-stat">
        <div className="strip-stat-inner">
          <div className="strip-stat-num">5★</div>
          <div className="strip-stat-label">Rated Events</div>
        </div>
      </div>
    </div>
  );
}
